export default {
  BusinessStockDistributionQtyAddSku: {
    title: 'Warehouse Space Quantity Allocation',
    supportWarehouseType: 'Supply Warehouse Type',
    supportWarehouseId: 'Supply Warehouse Name',
    receiveWarehouseType: 'Receiving Warehouse Type',
    receiveWarehouseId: 'Receiving Warehouse Name',
    spuCode: 'Product Code',
    spuName: 'Product Name',
    categoryId: 'Product Category',
    skuCode: 'SKU',
    supplyWarehouseList: 'Supply Warehouse Product List',
    warehouseType: 'Warehouse Type',
    realPosition: 'Real Warehouse',
    warehouseCode: 'Warehouse Code',
    warehouseName: 'Warehouse Name',
    distribute: 'Allocate',
    withdraw: 'Withdraw',
    receivingWarehouseList: 'Receiving Warehouse Product List',
    setQty: 'Batch Set',
    setQtyMsg1: 'Please select the receiving warehouse product on the right',
    setQtyMsg2: 'Please enter the bin quantity',
    setQtyMsg3: 'Batch set bin quantity',
    inputErrorMsg: 'Incorrect quantity format',
    errorMsg: 'cancel Input',
    msgWarning1: 'Please select the supply warehouse product on the left',
    msgWarning2: 'Please select the product first',

    table: {
      categoryName: 'Product Category',
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      qty: 'Bin Quantity'
    }
  }
};
